// Landing pages v2 (Irish's October 2026 designs) — shared behaviour for sections/lp-v2-*.liquid.
// Loaded after lp-avatar.js, which provides window.CARISMO_VEHICLES and the "#message-us" → Respond.io wiring.
// Page-specific behaviour (material tabs, the brand-new / 30k toggle) lives in its own section's <script>.
(function () {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // ---- Copy-to-clipboard code buttons ----
  // <button data-lp2-copy="BF26"> … <span data-lp2-copy-label data-copied="Copied">Tap to copy</span></button>
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text).catch(fallback);
    return Promise.resolve(fallback());
    function fallback() {
      const t = document.createElement('textarea');
      t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (e) {}
      t.remove();
    }
  }
  $$('[data-lp2-copy]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      copyText(btn.dataset.lp2Copy);
      $$('[data-lp2-copy-label]', btn).forEach((label) => {
        if (!label.dataset.idle) label.dataset.idle = label.textContent;
        label.textContent = label.dataset.copied || 'Copied';
        clearTimeout(label._t);
        label._t = setTimeout(() => { label.textContent = label.dataset.idle; }, 1800);
      });
    });
  });

  // ---- Make → Model picker ----
  // <div data-lp2-picker data-lp2-makes="BMW,Porsche" data-lp2-mode="collection|build">
  //   <select data-lp2-make> <select data-lp2-model> <a data-lp2-go href="(fallback)">
  $$('[data-lp2-picker]').forEach((box) => {
    const all = window.CARISMO_VEHICLES || {};
    const CATCH_ALL = 'Other / not listed';
    const chosen = box.dataset.lp2Makes ? box.dataset.lp2Makes.split(',').map((m) => m.trim()).filter(Boolean) : Object.keys(all);
    const makes = chosen.filter((m) => m !== CATCH_ALL && all[m]).concat(all[CATCH_ALL] ? [CATCH_ALL] : []);
    const mode = box.dataset.lp2Mode || 'collection';
    const make = $('[data-lp2-make]', box);
    const model = $('[data-lp2-model]', box);
    const go = $('[data-lp2-go]', box);
    if (!make || !model || !go) return;
    const fallback = go.getAttribute('href');
    const modelPrompt = model.options[0] ? model.options[0].textContent : 'Choose model';
    makes.forEach((m) => make.add(new Option(m, m)));
    model.disabled = true;
    make.addEventListener('change', () => {
      model.innerHTML = '';
      model.add(new Option(modelPrompt, ''));
      (all[make.value] || []).forEach((row) => model.add(new Option(row.label, row.label)));
      model.disabled = !make.value;
      go.setAttribute('href', fallback);
      go.dataset.ready = '';
    });
    model.addEventListener('change', () => {
      const row = (all[make.value] || []).find((r) => r.label === model.value);
      const path = row ? (mode === 'build' && row.build ? row.build : row.url) : fallback;
      go.setAttribute('href', path);
      go.dataset.ready = row ? '1' : '';
    });
    go.addEventListener('click', (e) => {
      if (go.dataset.ready) return;
      e.preventDefault();
      (make.value ? model : make).focus();
    });
  });

  // ---- Inline signup → the same Klaviyo lists the site popup uses ----
  // Popup "Grid & Pixel Web Pop-Up - Micro Commit": email step → list RAQGTj, SMS step → list TFUq9j.
  const KLAVIYO_COMPANY = 'TNyEDe';
  const EMAIL_LIST = 'RAQGTj';
  const SMS_LIST = 'TFUq9j';
  function e164(raw) {
    const d = String(raw || '').replace(/\D/g, '');
    if (!d) return '';
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d[0] === '1') return '+' + d;
    return String(raw).trim().startsWith('+') ? '+' + d : '';
  }
  function subscribe(list, attrs, source) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: list } } } } })
    }).then((r) => { if (!r.ok) throw new Error('Klaviyo ' + r.status); });
  }
  $$('form[data-lp2-signup]').forEach((form) => {
    const msg = $('[data-lp2-signup-msg]', form);
    const say = (text, ok) => { if (msg) { msg.textContent = text; msg.style.color = ok ? '' : (form.dataset.lp2ErrorColor || '#FFD7D7'); } }; // data-lp2-error-color for light bands
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = ($('input[type=email]', form) || {}).value || '';
      const phoneRaw = ($('input[type=tel]', form) || {}).value || '';
      const phone = e164(phoneRaw);
      if (!email.trim() && !phoneRaw.trim()) { say('Add your email or mobile number.'); return; }
      if (email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) { say('Check your email address.'); return; }
      if (phoneRaw.trim() && !phone) { say('Enter a US mobile number, or include the country code.'); return; }
      const source = form.dataset.lp2Source || ('Landing page ' + location.pathname);
      const jobs = [];
      if (email.trim()) jobs.push(subscribe(EMAIL_LIST, { email: email.trim(), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }, source));
      if (phone) jobs.push(subscribe(SMS_LIST, Object.assign({ phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' }, transactional: { consent: 'SUBSCRIBED' } } } },
        email.trim() ? { email: email.trim() } : {}), source));
      const btn = $('button[type=submit]', form);
      if (btn) btn.disabled = true;
      Promise.all(jobs).then(() => {
        form.reset();
        say(form.dataset.lp2Thanks || "You're in. Watch your inbox.", true);
      }).catch(() => {
        say('That didn’t go through. Try again, or message us.');
      }).finally(() => { if (btn) btn.disabled = false; });
    });
  });

  // ---- Before / after drag slider (snippets/lp-v2-compare.liquid) ----
  $$('[data-lp2-compare]').forEach((box) => {
    const range = $('input[type=range]', box);
    const set = (v) => { v = Math.max(0, Math.min(100, v)); box.style.setProperty('--pos', v + '%'); if (range) range.value = v; };
    const fromEvent = (e) => { const r = box.getBoundingClientRect(); set(((e.clientX - r.left) / r.width) * 100); };
    let dragging = false;
    box.addEventListener('pointerdown', (e) => { dragging = true; box.setPointerCapture(e.pointerId); fromEvent(e); });
    box.addEventListener('pointermove', (e) => { if (dragging) fromEvent(e); });
    const stop = () => { dragging = false; };
    box.addEventListener('pointerup', stop); box.addEventListener('pointercancel', stop);
    if (range) range.addEventListener('input', () => set(+range.value));
  });

  // ---- Install video tiles play in the page's embedded player (snippets/lp-v2-yt.liquid) ----
  // <a href="https://www.youtube.com/watch?v=ID" data-lp2-yt-play="ID" data-lp2-yt-target="main">
  $$('[data-lp2-yt-play]').forEach((tile) => {
    tile.addEventListener('click', (e) => {
      const player = $('[data-lp2-yt="' + (tile.dataset.lp2YtTarget || 'main') + '"]');
      const frame = player && $('iframe', player);
      if (!frame) return; // no player on the page: the link opens YouTube as normal
      e.preventDefault();
      frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(tile.dataset.lp2YtPlay) + '?rel=0&modestbranding=1&playsinline=1&autoplay=1';
      if (tile.dataset.lp2YtTitle) frame.title = tile.dataset.lp2YtTitle;
      player.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  // ---- Live "wheels in stock" total ----
  // Liquid can read 250 products per render, so the count template (?view=lp-v2-count) reports one
  // page at a time and this adds them up. <span data-lp2-instock-total data-format="[count] wheels…">fallback</span>
  const totals = $$('[data-lp2-instock-total]');
  if (totals.length) {
    const KEY = 'lp2-instock-total';
    const paint = (n) => totals.forEach((el) => { el.textContent = (el.dataset.format || '[count]').replace('[count]', n.toLocaleString('en-US')); });
    let cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.t < 10 * 60 * 1000) { paint(cached.n); }
    else {
      const url = (p) => location.pathname + '?view=lp-v2-count&page=' + p;
      const read = (html) => {
        const m = /data-lp2-count="(\d+)"[^>]*data-lp2-pages="(\d+)"/.exec(html);
        return m ? { n: +m[1], pages: +m[2] } : null;
      };
      fetch(url(1)).then((r) => r.text()).then((html) => {
        const first = read(html);
        if (!first) return;
        const rest = [];
        for (let p = 2; p <= first.pages; p++) rest.push(fetch(url(p)).then((r) => r.text()).then(read));
        return Promise.all(rest).then((more) => {
          if (more.some((x) => !x)) return;
          const n = more.reduce((sum, x) => sum + x.n, first.n);
          if (n > 0) {
            paint(n);
            try { sessionStorage.setItem(KEY, JSON.stringify({ n, t: Date.now() })); } catch (e) {}
          }
        });
      }).catch(() => {});
    }
  }
})();
